import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import affiliate from "../assets/images/img-k.png";
import { Link } from "react-router-dom";

const AffiliateJoin = () => {
  return (
    <>
      <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
        <Header />
        <div className="px-4 py-10">
          <div className="max-w-5xl mx-auto">
            <img src={affiliate} />
            <h1 className="text-3xl font-bold my-4">Affiliate Program</h1>

            <h2 className="text-xl font-semibold mb-2">
              Join The Affiliate Program
            </h2>
            <p className="mb-2">
              Believe you can exchange the world for the better with Bitcoin,
              Blockchain? Join the Affiliate Program, and get rewarded for your
              efforts when you introduce your world to Tillionx, the world’s
              leading cryptocurrency exchange.
            </p>
            <p className="mb-2">
              Please complete this form and we will reach out to you if you meet
              the program criteria. For information regarding the Affiliate
              Program, visit our Affiliate Blog or our Affiliate Support Guide.
            </p>
            <p className="mb-4">Thank you for applying.</p>

            <form className="space-y-6">
              <div>
                <label className="block font-semibold mb-1">
                  1. Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter name"
                  className="w-full border border-gray-300 rounded px-3 py-2 bg-transparent"
                  required
                />
              </div>

              <div>
                <label className="block font-semibold mb-1">
                  2. Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  placeholder="Enter email"
                  className="w-full border border-gray-300 rounded px-3 py-2 bg-transparent"
                  required
                />
              </div>

              <div>
                <label className="block font-semibold mb-1">
                  3. Phone Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  placeholder="Enter the phone number"
                  className="w-full border border-gray-300 rounded px-3 py-2 bg-transparent"
                  required
                />
              </div>

              <div>
                <label className="block font-semibold mb-1">
                  4. How do we contact you? (through Social Media){" "}
                  <span className="text-red-500">*</span>
                </label>
                <select
                  className="w-full border border-gray-300 rounded px-3 py-2 bg-transparent"
                  required
                >
                  <option value="">Select</option>
                  <option value="telegram">Telegram</option>
                  <option value="twitter">Twitter</option>
                  <option value="instagram">Instagram</option>
                  <option value="facebook">Facebook</option>
                </select>
              </div>

              <div>
                <label className="block font-semibold mb-1">
                  5. Username (to contact you on Social Media){" "}
                  <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter username"
                  className="w-full border border-gray-300 rounded px-3 py-2 bg-transparent"
                  required
                />
              </div>

              <div>
                <label className="block font-semibold mb-1">
                  6. What country or region do you plan on marketing in?{" "}
                  <span className="text-red-500">*</span>
                </label>
                <select
                  className="w-full border border-gray-300 rounded px-3 py-2 bg-transparent"
                  required
                >
                  <option value="">Select</option>
                  <option>India</option>
                  <option>USA</option>
                  <option>UK</option>
                  <option>UAE</option>
                  <option>Other</option>
                </select>
              </div>

              <div>
                <label className="block font-semibold mb-2">
                  7. Select your Affiliate type{" "}
                  <span className="text-red-500">*</span>
                </label>
                <div className="space-y-2">
                  <label className="block">
                    <input
                      type="radio"
                      name="affiliateType"
                      value="crypto-individual"
                      className="mr-2"
                    />
                    Crypto Influencer (Individual)
                  </label>
                  <label className="block">
                    <input
                      type="radio"
                      name="affiliateType"
                      value="crypto-org"
                      className="mr-2"
                    />
                    Crypto Institution/Organization
                  </label>
                  <label className="block">
                    <input
                      type="radio"
                      name="affiliateType"
                      value="social-influencer"
                      className="mr-2"
                    />
                    Social Influencer (Non-Crypto Community)
                  </label>
                  <label className="block">
                    <input
                      type="radio"
                      name="affiliateType"
                      value="noncrypto-org"
                      className="mr-2"
                    />
                    Non-Crypto Institution/Organization
                  </label>
                </div>
              </div>

              <div>
                <label className="block font-semibold mb-1">
                  8. Brief introduction about yourself and platform/community{" "}
                  <span className="text-red-500">*</span>
                </label>
                <textarea
                  placeholder="Enter description and number of followers"
                  rows="4"
                  className="w-full border border-gray-300 rounded px-3 py-2 bg-transparent"
                  required
                />
              </div>

              <div>
                <label className="block font-semibold mb-1">
                  9. Primary Platform/Channel for promoting{" "}
                  <span className="text-red-500">*</span>
                </label>
                <select
                  className="w-full border border-gray-300 rounded px-3 py-2 bg-transparent"
                  required
                >
                  <option value="">Select</option>
                  <option>Telegram</option>
                  <option>Twitter</option>
                  <option>Instagram</option>
                  <option>YouTube</option>
                  <option>Other</option>
                </select>
              </div>

              <div>
                <label className="block font-semibold mb-1">
                  10. How many followers/members/users do you have on your
                  primary platform? <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  placeholder="Enter number of followers/members/users"
                  className="w-full border border-gray-300 rounded px-3 py-2 bg-transparent"
                  required
                />
              </div>

              <div>
                <label className="block font-semibold mb-1">
                  11. Screenshot of performance metrics on your platforms{" "}
                  <span className="text-red-500">*</span>
                </label>
                <div className="w-48 h-48 flex items-center justify-center border-2 border-dashed rounded cursor-pointer hover:bg-gray-50">
                  <label
                    htmlFor="fileUpload"
                    className="flex flex-col items-center justify-center w-full h-full text-gray-500"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-8 w-8 mb-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4v16m8-8H4"
                      />
                    </svg>
                    Add
                    <input
                      id="fileUpload"
                      type="file"
                      className="hidden"
                      accept="image/*"
                      required
                    />
                  </label>
                </div>
              </div>

              <div>
                <label className="block font-semibold mb-1">
                  12. Is there anything else that you would like to share?
                </label>
                <textarea
                  placeholder="Your answer"
                  className="w-full border border-gray-300 rounded px-3 py-2 bg-transparent"
                  rows="3"
                />
              </div>

              <div>
                <label className="block font-semibold mb-1">
                  13. By submitting this application, I acknowledge to have read
                  and agree to the Tillionx Affiliate Program Standard Terms and
                  Conditions. <span className="text-red-500">*</span>
                </label>
                <p className="text-sm text-gray-500 mb-2">
                  You can find Tillionx Affiliate Program Standard Terms and
                  Conditions{" "}
                  <Link to={"/"} className="text-yellow-500 underline">
                    here
                  </Link>
                </p>
                <label className="inline-flex items-center space-x-2">
                  <input
                    type="radio"
                    name="terms"
                    required
                    className="text-yellow-500"
                  />
                  <span>Yes</span>
                </label>
              </div>

              <div className="flex space-x-4 mt-6">
                <button
                  type="submit"
                  className="bg-yellow-400 text-black font-semibold px-6 py-2 rounded hover:bg-yellow-300 transition"
                >
                  Submit
                </button>
                <button
                  type="reset"
                  className="bg-gray-200 text-black font-semibold px-6 py-2 rounded hover:bg-gray-300 transition"
                >
                  Reset
                </button>
              </div>

              {/* <button
                type="submit"
                className="bg-yellow-400 text-black font-semibold px-6 py-2 rounded hover:bg-yellow-300 transition"
              >
                Submit Application
              </button> */}
            </form>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default AffiliateJoin;
